export const formatToUTCISO = (date: Date | string): string => {
  let dateObj: Date;

  if (typeof date === 'string') {
    dateObj = new Date(date);
  } else {
    dateObj = date;
  }

  const localTime = new Date(dateObj);
  localTime.setHours(0, 0, 0, 0);

  const utcDate = new Date(
    localTime.getTime() - localTime.getTimezoneOffset() * 60000
  );

  return utcDate.toISOString();
};
